<div class="row">

    <div class="col-12">

        <div class="card">

            <div class="card-header">
                <div class="title">Интеграция между организациями</div>
                <div class="tools">
                    <button type="button" class="btn btn-light btn-sm" routerLink="/integration">
                        <i class="bi bi-backspace"></i> {{ 'BACK_TO_LIST' | translate }}
                    </button>
                    <button type="button" class="btn btn-primary btn-sm" (click)="onCreate()" [disabled]="codes.length == 0 || loading">
                        <i class="bi bi-save"></i> {{ 'SAVE' | translate }}
                    </button>
                </div>
            </div>

            <div class="card-body">

                <div class="card-body-title">Параметры интеграции</div>

                    <form class="form" [formGroup]="form" autocomplete="off">

                        <div class="row">
                
                            <div class="col-6">
                                <div class="form-group">
                                    <label class="filter-label" for="org_id"> Организации:</label>
                                    <ng-select 
                                    id="org_id" 
                                    class="custom" 
                                    clearAllText="{{ 'CLEAR' | translate }}" 
                                    notFoundText="{{ 'NO_DATA' | translate }}"
                                    bindValue="org_id"
                                    bindLabel="name" 
                                    formControlName="org_id" 
                                    [multiple]="false" 
                                    [items]="orgs">
                                    </ng-select>
                                    <!-- <div *ngFor="let item of errorMessages.attribute">
                                        <div class="text-error" *ngIf="validation('attribute', item.type)">
                                            {{ item.message | translate: item.options }}
                                        </div>
                                    </div> -->
                                </div>
                            </div>

                            <div class="col-6 btn-block">
                                <button type="button" class="btn btn-primary btn-sm" (click)="getBarcodes()" [disabled]="form.invalid || loading"> Получить данные</button>
                            </div>

                            <div class="col-12 filter-label" *ngIf="count != 0" style="margin-top: 5px;">
                                <span>Количество записей: {{count}}</span>
                            </div>

                            <div class="col-12">

                                <table class="table table-hover head">
                                    <thead>
                                        <tr>
                                            <!-- <th scope="col" class="checkbox">
                                                <div class="custom-control custom-checkbox">
                                                    <input class="custom-control-input" type="checkbox" name="select_template_all"
                                                        id="select_preset_all" [checked]="isAllCheckBoxChecked()"
                                                        [indeterminate]="checkedButNotAllCheckBox()"
                                                        (change)="checkAllCheckBox($event)">
                                                    <label class="custom-control-label" for="select_template_all"></label>
                                                </div>
                                            </th> -->
                                            <th scope="col" class="name">Штрих-код </th>
                                        </tr>
                                    </thead>
                                </table>

                            </div>

                            <div class="col-12 scroll-table">
                                
                                <table class="table table-hover">
                                    <!-- <thead>
                                        <tr>
                                            <th scope="col" class="checkbox">
                                                <div class="custom-control custom-checkbox">
                                                    <input class="custom-control-input" type="checkbox" name="select_template_all"
                                                        id="select_preset_all" [checked]="isAllCheckBoxChecked()"
                                                        [indeterminate]="checkedButNotAllCheckBox()"
                                                        (change)="checkAllCheckBox($event)">
                                                    <label class="custom-control-label" for="select_template_all"></label>
                                                </div>
                                            </th>
                                            <th scope="col" class="name">Наименование </th>
                                        </tr>
                                    </thead> -->
                
                                    <!-- <div class="tbody"> -->
                                        <tbody *ngIf="codes && codes.length > 0">
                                            <tr *ngFor="let code of codes; let i = index">
                                                <!-- <td class="checkbox">
                                                    <div class="custom-control custom-checkbox">
                                                        <input class="custom-control-input" type="checkbox" name="select_template_{{ i }}"
                                                            id="select_template_{{ i }}" [checked]="template.checked"
                                                            (change)="selectedCheckBox(i, $event)">
                                                        <label class="custom-control-label" for="select_template_{{ i }}"></label>
                                                    </div>
                                                </td> -->
                                                <td class="name">{{ code }}</td>
                                            </tr>
                                        </tbody>
                                    <!-- </div> -->

                                    <tbody *ngIf="!codes || codes.length == 0">
                                        <tr>
                                            <td *ngIf="loading" class="data-loading" colspan="1">
                                                <div class="spinner-bars">
                                                    <div class="loadingio-spinner-bars-preLoder-inner">
                                                        <div class="preLoder">
                                                            <div></div><div></div><div></div><div></div>
                                                        </div>
                                                    </div>
                                                    <div>{{ 'LOADING' | translate }}</div>
                                                </div>
                                            </td>
                                            <td *ngIf="!loading" class="data-not-found" colspan="1">
                                                <div>{{ 'DATA_NOT_FOUND' | translate }}</div>
                                            </td>
                                        </tr>
                                    </tbody>

                                </table>

                            </div>

                        </div>

                    </form>

            </div>

        </div>

    </div>

</div>